const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamShirt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.414,
    height: 30,
    viewBox: "0 0 38.414 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 164954"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Subtra\\xE7\\xE3o 10",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.047 30H8.371V11.941l-2.926 1.895L0 5.461 8.371.012V0h8.477A2.5 2.5 0 0 0 19.2 3.332a2.5 2.5 0 0 0 2.508-2.5A2.577 2.577 0 0 0 21.566 0h8.48v.02l8.364 5.433-5.449 8.383-2.914-1.887V30z",
    style: {
      stroke: "none"
    },
    transform: "translate(.004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.047 28V11.95a2 2 0 0 1 3.087-1.68l1.238.802 3.271-5.032L29.424 2h-5.866a4.504 4.504 0 0 1-8.698 0H8.982L2.763 6.047l3.27 5.025 1.251-.81a2 2 0 0 1 3.087 1.68V28h17.676m2 2H8.37V11.941l-2.926 1.895L-.004 5.46 8.371.01 8.375 0h8.477a2.498 2.498 0 0 0 2.352 3.332A2.503 2.503 0 0 0 21.71.836c0-.281-.05-.563-.145-.836h8.48v.02l8.364 5.433-5.45 8.383-2.913-1.887V30z",
    style: {
      fill: "currentColor",
      stroke: "none"
    },
    transform: "translate(.004)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 164167"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 427",
    transform: "translate(15.207 12.75)",
    style: {
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      fill: "none"
    },
    d: "M0 0v6.167"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Elipse 9514",
    transform: "translate(17.707 11.667)",
    style: {
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.333,
    cy: 4.167,
    rx: 3.333,
    ry: 4.167,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.333,
    cy: 4.167,
    rx: 2.333,
    ry: 3.167,
    style: {
      fill: "none"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamShirt);
export default __webpack_public_path__ + "static/media/TeamShirt.43c9c80b553453256385edd1fffeaedc.svg";
export { ForwardRef as ReactComponent };